<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'LanguageToggle',
});
</script>
<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { Select } from '@element-plus/icons-vue';
import { useLanguageToggle } from '@klondpay/composables';

;

withDefaults(
  defineProps<{
    /** 是否显示语言切换 */
    show?: boolean;
  }>(),
  {
    show: true,
  },
);

const emit = defineEmits<{
  change: [locale: string];
}>();

const { t } = useI18n();

// 使用组合式函数管理语言状态
const {
  currentLocale,
  isChinese,
  isEnglish,
  changeLanguage,
  switchToChinese: doSwitchToChinese,
  switchToEnglish: doSwitchToEnglish,
} = useLanguageToggle();

/**
 * 切换到中文并触发事件
 */
const switchToChinese = async () => {
  await doSwitchToChinese();
  emit('change', 'zh-CN');
  window.location.reload();
};

/**
 * 切换到英文并触发事件
 */
const switchToEnglish = async () => {
  await doSwitchToEnglish();
  emit('change', 'en-US');
  window.location.reload();
};

/**
 * 切换到指定语言并触发事件
 */
const handleLanguageChange = async (locale: string) => {
  await changeLanguage(locale as 'zh-CN' | 'en-US');
  emit('change', locale);
  window.location.reload();
};

// 兼容旧版本的语言判断（包含简写形式）
const isChineseCompat = computed(() => isChinese.value || currentLocale.value === 'zh');
const isEnglishCompat = computed(() => isEnglish.value || currentLocale.value === 'en');

// 暴露方法供外部调用
defineExpose({
  currentLocale,
  isChinese: isChineseCompat,
  isEnglish: isEnglishCompat,
  handleLanguageChange,
  switchToChinese,
  switchToEnglish,
});
</script>

<template>
  <div v-if="show" class="lang-box">
    <slot
      :locale="currentLocale"
      :is-chinese="isChineseCompat"
      :is-english="isEnglishCompat"
      :change="handleLanguageChange"
      :switch-to-chinese="switchToChinese"
      :switch-to-english="switchToEnglish"
    >
      <el-dropdown trigger="click" :hide-on-click="true">
        <img class="el-dropdown-link" src="../../assets/images/lang.png" alt="language" />
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item style="width: 119px; height: 36px" @click="switchToChinese">
              <el-icon
                v-show="isChineseCompat"
                style="position: relative; margin-right: 10px; vertical-align: middle"
              >
                <Select />
              </el-icon>
              <span style="position: absolute; left: 40px">{{ t('中文') }}</span>
            </el-dropdown-item>
            <el-dropdown-item style="width: 119px; height: 36px" @click="switchToEnglish">
              <el-icon
                v-show="isEnglishCompat"
                style="position: relative; margin-right: 10px; vertical-align: middle"
              >
                <Select />
              </el-icon>
              <span style="position: absolute; left: 40px">English</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </slot>
  </div>
</template>

<style lang="scss" scoped>
.lang-box {
  position: fixed;
  top: 60px;
  right: 60px;
  z-index: 100;
  cursor: pointer;

  .el-dropdown-link {
    width: 42px;
    height: 42px;
  }
}
</style>
